import { TablePageLayout } from '@common/components/TablePageLayout';
import { OrdersTable } from '@features/orders/components/OrdersTable';
import { OrdersToolbar } from '@features/orders/components/OrdersToolbar';
import { useOrdersFiltersUrl } from '@features/orders/hooks/useOrdersFiltersUrl';

export default function OrdersPage(): React.ReactNode {
	// Sync order filters with URL query parameters
	useOrdersFiltersUrl();

	return (
		<TablePageLayout
			title='Orders'
			aboveTableContent={<OrdersToolbar />}
			tableContent={<OrdersTable />}></TablePageLayout>
	);
}
